var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"habit-name"},[_c('explanation',{attrs:{"caption":"習慣名","description":"習慣の名前を設定します。"}}),_c('input-name'),_c('button-set-name')],1)}
var staticRenderFns = []

export { render, staticRenderFns }